import { EdgeListTodoCategoriesForOrgRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ListTodoCategoriesForOrg } from '@/shared/domain/use-cases'

export function makeListTodoCategoriesForOrg(): ListTodoCategoriesForOrg {
  return new EdgeListTodoCategoriesForOrgRepository(makeSupabaseEdgeHttpClient()).execute
}
